<template>
    <div>
        <div>
            <Title
                class="md:block md:mt-4 md:mb-4"
                :class="{ 'hidden': aplCatl === aplCatlCode.POLICY }"
                :text="$route.meta.pageTitle"
                style-code-page
            />
            <div class="min-h-[30vh]">
                <transition
                    name="opacity"
                    mode="out-in"
                >
                    <div v-if="!hasData">
                        <template v-if="aplCatl !== aplCatlCode.POLICY">
                            <SkeletonConfirmData />
                        </template>
                        <template v-else>
                            <div
                                v-for="(item, index) in changeItems"
                                :key="index"
                            >
                                <SkeletonConfirmData />
                            </div>
                        </template>
                    </div>
                    <div v-else>
                        <template
                            v-for="(item, index) in Object.keys(result)"
                            :key="index"
                        >
                            <component
                                :is="childComponents[item]"
                                v-if="result[item]"
                                :key="index"
                                :result="result[item]"
                                @removeService="removeService"
                            />
                        </template>
                    </div>
                </transition>
            </div>
            <div
                v-if="isShowEndorse"
                class="md:flex-nowrap items-centerh4 text-gray-600"
            >
                <div class="flex pt-1 pr-3">
                    <input
                        v-model="checkboxAgree"
                        type="radio"
                        name="checkboxAgree"
                        :value="true"
                        class="mr-3"
                    >
                    本次變更批註內容將以電子文件寄送至本次填寫或本人留存於貴公司之電子郵件信箱；未提供電子郵件信箱或郵件遭退回，則發送簡訊通知；若未留存行動電話或簡訊通知亦遭退回，則改以紙本寄送。若您未申請電子保單且不同意以電子文件寄送請勾選『變更批註以紙本寄送』。
                </div>
                <br>
                <div class="flex pt-1 pr-3">
                    <input
                        v-model="checkboxAgree"
                        type="radio"
                        name="checkboxAgree"
                        :value="false"
                        class="md:mr-1.5"
                    >
                    變更批註以紙本寄送
                </div>
            </div>
            <div
                v-if="isShowAgentAgree"
                class="flex flex-wrap md:flex-nowrap items-center justify-end border-t md:border-0 pt-5 h4 text-gray-600"
            >
                <div class="w-full md:w-auto flex justify-end md:flex-none">
                    <Radio
                        v-model:checked-value="isAgree"
                        value="Y"
                        text="同意"
                        class="mr-3"
                    />
                    <Radio
                        v-model:checked-value="isAgree"
                        value="N"
                        text="不同意"
                        class="md:mr-1.5"
                    />
                </div>
                <div>
                    將本次交易申請通知保單招攬人員{{ result.agentName }}
                </div>
            </div>
        </div>
        <Bottombar>
            <template #right>
                <button
                    v-if="aplCatl === aplCatlCode.POLICY"
                    class="btn btn-outline rounded-full"
                    @click="AddServicePage()"
                >
                    加入其他變更
                </button>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="isDisabledButton || !hasData"
                    @click="mobileVerify()"
                >
                    確定
                </button>
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
        <PopupRemove
            v-model:visiblePopup="visiblePopup"
            :code="removeServiceCode"
            @goNext="goNext"
        />
        <!-- 門號核實 -->
        <ModalMobileVerify
            v-model:postApiMid="postApiMid"
            @confirm="confirmApiMid"
        />
    </div>
</template>
<script>
import { ref, computed, provide, inject } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { confirmTransaction, getResult } from '@/apis/system';
import { getNeedMIDVerify } from '@/apis/mid';
import routeName from '@/router/constant.js';
import Bottombar from '@/components/layout/Bottombar.vue';
import Title from '@/components/text/Title.vue';
import Loading from '@/components/Loading.vue';
import PopupRemove from '@/components/dialogs/PopupRemove.vue';
import SkeletonConfirmData from '@/components/skeletons/SkeletonConfirmData.vue';
import Radio from '@/components/radios/Radio.vue';
import childComponents from './childComponents';
import aplCatlCode from '@/json/aplCatlCode';
import ModalMobileVerify from '@/components/dialogs/ModalMobileVerify/ModalMobileVerify.vue';
import { makeSort } from '@/utils/array/makeSort';
import { submitACH } from '@/apis/aplCatlACH.js';
import codeList from '@/json/codeList.js';
import { postAgreeEndorse, postNotAgreeEndorse } from '@/apis/endorse.js';
import Checkbox from '@/components/checkboxs/Checkbox.vue';

export default {
    name: 'ConfirmData',
    components: {
        Bottombar,
        Title,
        Loading,
        SkeletonConfirmData,
        Radio,
        PopupRemove,
        ModalMobileVerify,
        ...childComponents,
        Checkbox,
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const store = useStore();
        const isAgree = ref('');
        const isEndorseAgree = ref('');
        const isLoading = ref(false);
        const hasData = ref(false);
        const visiblePopup = ref(false);
        const removeServiceCode = ref('');
        const postApiMid = ref(false);
        const allButtons = computed(() => store.state.services.transactionItems);
        const gettersServiceList = computed(() => store.state.services.serviceList);
        const applyWay = computed(() => store.state.services.changeItemsResult[`${codeList.ACH}applyWay`]);
        const checkboxAgree = ref(true); // 是否以電子文件寄送本次變更批註內容 checkbox
        const changeItems = computed(() => {
            const list = allButtons.value ? allButtons.value.filter(i => i.userChecked) : [];
            return list;
        });
        const aplCatl = computed(() => store.state.services.aplCatl);
        provide('aplCatl', aplCatl);

        const result = ref({});
        const resultLength = computed(() => {
            const keys = Object.keys(result.value).filter(i => i !== 'agentName' && i !== 'needEndorse' && i !== 'needEndorseDesc');
            const ary = keys.filter(key => {
                return result.value[key] !== null;
            });
            return ary.length;
        });

        // 標記抵達確認頁面的flag
        (() => {
            const list = allButtons.value.map(i => {
                gettersServiceList.value.map(j => {
                    if (i.transactionItemNo === j.transactionItemNo) {
                        i.confirm = true;
                    }
                });
                // 如果有選取投資屬性問卷也註記flag
                if (i.transactionItemNo === 'IQ' && i.userChecked) {
                    i.confirm = true;
                }
                return i;
            });
            store.dispatch('services/setTransactionItems', list);
        })();

        const getResultData = () => {
            getResult().then(res => {
                const list = allButtons.value ? makeSort(allButtons.value, 'transactionItemOrder').filter(i => i.userChecked) : [];
                console.log('list' + list);
                const keys = list.map(i => i.transactionItemNo.toUpperCase());
                keys.forEach(key => {
                    result.value[key.toUpperCase()] = res.data[key.toLowerCase()];
                });
                result.value.agentName = res.data.agentName;
                result.value.needEndorse = res.data.needEndorse;
                result.value.needEndorseDesc = res.data.needEndorseDesc;
                hasData.value = res.success;
            });
        };
        getResultData();

        /** 640/631與有agentName的 顯示通知招攬人員 */
        const isShowAgentAgree = computed(() => {
            return (aplCatl.value === aplCatlCode.POLICY || aplCatl.value === aplCatlCode.CONTACT) && result.value.agentName?.length > 0;
        });

        /** 下一步按鈕disabled判斷 */
        const isDisabledButton = computed(() => {
            let isDisabled = false;
            if (aplCatl.value === aplCatlCode.POLICY || aplCatl.value === aplCatlCode.CONTACT) {
                if (result.value.agentName?.length > 0) {
                    isDisabled = isAgree.value === '';
                }
            }
            return isDisabled;
        });

        const AddServicePage = () => {
            router.push({
                name: routeName.ADD_SERVICE
            });
        };
        // 刪除成功之後
        const goNext = () => {
            // 除了640，其他項目只有一個交易項目，刪除即回首頁
            if (resultLength.value === 1) {
                router.push({ name: routeName.HOME });
            } else {
                result.value[removeServiceCode.value] = null;
                getResultData();
            }
        };
        // 按下確認按鈕
        const mobileVerify = () => {
            if (isDisabledButton.value) return;
            if (aplCatl.value === aplCatlCode.POLICY || aplCatl.value === aplCatlCode.CONTACT) {
                /* 開始門號核實 */
                getNeedMIDVerify().then(res => {
                    if (res.data.flag) {
                        postApiMid.value = true;
                    } else {
                        goNextPage();
                    }
                });
            } else {
                goNextPage();
            };
        };

        // 網銀帳密驗證驗證
        const modalShow = (params, on) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on,
            });
        };

        // 送出ACH確認
        const submitDataACH = () => {
            isLoading.value = true;
            submitACH().then(res => {
                if (applyWay.value.type === 'LinkPay') {
                    router.push({ name: routeName.FINISH });
                } else {
                    if (res.data.status) {
                        const { paymentURL, barCode } = res.data;
                        store.dispatch('services/setChangeItemsResult', { code: `${codeList.ACH}Submit`, value: { paymentURL, barCode } });
                        router.push({ name: routeName.AUTH_READING });
                    } else {
                        router.push({ name: routeName.FINISH });
                    }
                }
                isLoading.value = false;
            }).catch(() => {
                isLoading.value = false;
            });
        };

        // 送出確認資料
        const checkData = () => {
            return confirmTransaction(isAgree.value).then(res => res.data).catch(() => null);
        };

        const checkEndorseData = () => {
            if (isShowEndorse.value && isEndorseAgree.value) {
                return postAgreeEndorse().then(res => res.data).catch(() => null);
            } else {
                return true;
            }
        };

        const goNextPage = async () => {
            // if (isDisabledButton.value) return;
            isLoading.value = true;

            if (isShowEndorse.value) {
                if(checkboxAgree.value) {
                    await postAgreeEndorse();
                } else {
                    await postNotAgreeEndorse();
                }                
            } 

            const response = await checkData();
            if (response) {
                if (aplCatl.value === aplCatlCode.ACH) {
                    if (applyWay.value.type === 'LinkPay') {
                        await submitDataACH();
                    } else {
                        modalShow({
                            title: '網銀帳密驗證',
                            content: result.value.ACH?.alertMessage,
                            confirmButton: '確認',
                        }, {
                            confirm() {
                                submitDataACH();
                                $vfm.hide('DialogBase');
                            },
                        });
                    }
                } else {
                    let nextRouteName = routeName.OTP;
                    // 保單變更流程需要判斷是否有需要補/退費
                    if (aplCatl.value === aplCatlCode.POLICY) {
                        const transactionItems = store.state.services.transactionItems;
                        const list = transactionItems ? transactionItems.filter(i => i.userChecked) : [];
                        const hasRefundPayment = list.find(i => i.needRefund || i.needSupplement);
                        nextRouteName = hasRefundPayment ? routeName.REFUND_PAYMENT : routeName.OTP;
                        // 電子化授權 下一頁去授權loading頁面
                    }

                    // 借款變更流程需要判斷是否有政府方案的活動
                    if (aplCatl.value === aplCatlCode.PON4300 && response.activity) {
                        if (response.activityCode === '01') {
                            nextRouteName = routeName.LOAN_PROGRAM;
                        }
                    }
                    router.push({ name: nextRouteName });
                }
            } else {
                isLoading.value = false;
            }
        };

        // 刪除單一項目跳出燈箱
        const removeService = (code) => {
            removeServiceCode.value = code;
            visiblePopup.value = true;
        };

        const confirmApiMid = () => {
            goNextPage();
        };

        const isShowEndorse = computed(() => {
            return result.value.needEndorse;
        });

        return {
            childComponents,
            removeServiceCode,
            isAgree,
            isShowAgentAgree,
            isDisabledButton,
            AddServicePage,
            removeService,
            goNextPage,
            goNext,
            changeItems,
            aplCatlCode,
            aplCatl,
            isLoading,
            hasData,
            visiblePopup,
            resultLength,
            result,
            postApiMid,
            confirmApiMid,
            // closeApiMid,
            mobileVerify,
            isShowEndorse,
            isEndorseAgree,
            checkboxAgree,
        };
    },
};
</script>
